// extracted by mini-css-extract-plugin
export default {"noContenScreen":"styles_noContenScreen__FVOz1","noContent":"styles_noContent__wnvMW"};